import { FilterComponentProps } from "./Interface/FilterComponentProps";

export function TextFilterComponent({ filter, filterText, handleFilterTextChange }: FilterComponentProps) {
    return (
        <input
            id={`search-${filter.id}`}
            type="search"
            placeholder="Search..."
            aria-label="Search input"
            value={filterText}
            onChange={handleFilterTextChange}
            className="filter-component-container" />
    );
}
